import Vue from 'vue'
import Router from 'vue-router'
import WebStart from '@/views/web/Start.vue'
import WebReturns from '@/views/web/Returns.vue'
import Delivery from '@/views/web/Delivery.vue'
import EmergencyLabels from '@/views/web/EmergencyLabelView.vue'
import BundleBlocks from '@/views/web/BundleBlocks.vue'
import Journal from '@/views/web/JournalView.vue'
import InvoiceList from '@/views/web/InvoiceList.vue'
import Holiday from '@/views/web/Holidays.vue'
import BundlesOrder from '@/views/web/BundlesOrder.vue'
import Historic from '@/views/web/Historic.vue'
import BundleSearch from '@/views/web/BundleSearch.vue'
import Provision from '@/views/web/Provision.vue'
import Placard from '@/views/web/Placard.vue'
import store from '@/store'
import WebLayout from '@/layouts/WebLayout.vue'
import * as rs from '@/model/reportState'
import settings from '@/model/settings'

Vue.use(Router)

// hooks
// beforeRouteUpdate (to, from, next) {
//   // react to route changes...
//   // don't forget to call next()
//   console.log('Route:', to, from, next)
// }


const routes = [ 
  {
    path: '/',
    name: 'root',
    beforeEnter() {
      window.location.href = settings.route.www//'https://www-dev.kvallstidningarna.se/'
    },
    component: WebStart,
    meta: { layout: WebLayout }
  },
  {
    path: '/rapportering/:reportState',
    name: 'returrapportera',
    component: WebReturns,
    meta: { 
      title:'Returrapportering',
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/rapportering/:reportState',
    name: 'tillagg',   
    props:true,
    component: WebReturns,
    meta: { 
      title:'Returrapportering',
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/tillaggsrapportering',
    redirect: () =>{      
      return { name: 'tillagg', params: { reportState: rs.REPORTED } }
    },    
    component: WebReturns,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/returrapportering',
    redirect: () => {      
      return { name: 'returrapportera', params: { reportState: rs.NOT_REPORTED } }
    },    
    component: WebReturns,
    meta: { 
      title:'Returrapportering',
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/historik', 
    name:'historik',
    component: Historic,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/buntsok', 
    name:'buntsok',
    component: BundleSearch,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/mina-tjanster',
    redirect: () => {      
      return { name: 'foljesedel' }
    },    
    component: Delivery,
    meta: { 
      title:'Mina tjänster',
      layout: WebLayout,
      requiresAuth: true 
    }
  },
  {
    path: '/foljesedel',
    name: 'foljesedel',
    component: Delivery,
    meta: { 
      title:'Mina tjänster',
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/nodetiketter',
    name: 'nodetiketter',
    component: EmergencyLabels,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/buntblock',
    name: 'buntblock',
    component: BundleBlocks,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/journal',
    name: 'journal',
    component: Journal,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/faktura',
    name: 'faktura',
    component: InvoiceList,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/helgsparr',
    name: 'helgsparr',
    component: Holiday,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },    
  {
    path: '/order',
    name: 'order',
    component: BundlesOrder,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  }, 
  {
    path: '/provision',
    name: 'provision',
    component: Provision,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }    
  }, 
  {
    path: '/lopsedlar',
    name: 'lopsedlar',
    component: Placard,
    meta: { 
      layout: WebLayout,
      requiresAuth: true 
    }
  },      
  {
    path: '/start',
    name:'start',
    beforeEnter() {
        window.location.href = settings.route.www//'https://www-dev.kvallstidningarna.se/'
    }
  },
  {
    path: '/webbshop',
    name:'webbshop',
    beforeEnter() {
        window.location.href = settings.route.shop
    }
  },
  {
    path:'/login',
    name:'login',
    // component: WebStart,
    //  meta: { layout: WebLayout }
   beforeEnter(){
      window.location.href =  settings.route.www+'/behorighet-saknas/'//'https://www-dev.kvallstidningarna.se/behorighet-saknas/'
    }  
  },
  {
    path:'/logout',
    name:'logout',
    beforeEnter(){
      window.location.href = settings.route.www+'/logout' //'https://www-dev.kvallstidningarna.se/logout/'
    }  
  }
  
]

let router = new Router({
  mode: 'history',  
  routes
})

router.beforeEach((to, from, next) => {
  if( from.fullPath === '/'){
    if( to.name === 'returrapportera' ||
       to.name === 'foljesedel'){
      to.meta.showMenu = true
    }    
  }
  
  if( to.name !== 'logout'){
    next()
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {          
    if(store.getters.user === undefined){
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    }
    
    const token = Vue.$cookies.isKey('auth_token')        
    if (!token ) {
        next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
      } else {       
        next()          
      } 
  }else {
      next()
  }
})

export default router

